import React, { useState } from "react";

const PasswordInput = ({ label, label2, register, placeholder, error }) => {
  const [show, setShow] = useState(false);

  return (
    <div className="flex flex-col items-start w-full mt-5 relative">
      <label
        htmlFor="password"
        className="mb-1 font-[500] text-[13px] text-[#1B2559]"
      >
        {label}
      </label>
      <div className="relative w-full">
        <input
          className={`py-[18px] h-[50px] px-4 text-text-primary placeholder:text-[#A3AED0] rounded-[16px] w-full text-[16px] outline-none border-[1px] ${
            error ? "border-red-500" : "focus:border-primary"
          }`}
          type={show ? "text" : "password"}
          placeholder={placeholder}
          id="password"
          {...register} // spread the register props from react-hook-form
        />
        <div className="absolute top-[55%] right-[15px] transform -translate-y-1/2">
          <button type="button" onClick={() => setShow((pre) => !pre)}>
            {show ? (
              <div
                dangerouslySetInnerHTML={{
                  __html: `<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="text-[22px] text-black iconify iconify--ic" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M12 6a9.77 9.77 0 0 1 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5A9.77 9.77 0 0 1 12 6m0-2C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4m0 5a2.5 2.5 0 0 1 0 5a2.5 2.5 0 0 1 0-5m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7"></path></svg>`,
                }}
              />
            ) : (
              <div
                dangerouslySetInnerHTML={{
                  __html: `<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" aria-hidden="true" role="img" class="text-[22px] text-black iconify iconify--mdi" width="1em" height="1em" viewBox="0 0 24 24"><path fill="currentColor" d="M2 5.27L3.28 4L20 20.72L18.73 22l-3.08-3.08c-1.15.38-2.37.58-3.65.58c-5 0-9.27-3.11-11-7.5c.69-1.76 1.79-3.31 3.19-4.54zM12 9a3 3 0 0 1 3 3a3 3 0 0 1-.17 1L11 9.17A3 3 0 0 1 12 9m0-4.5c5 0 9.27 3.11 11 7.5a11.79 11.79 0 0 1-4 5.19l-1.42-1.43A9.862 9.862 0 0 0 20.82 12A9.821 9.821 0 0 0 12 6.5c-1.09 0-2.16.18-3.16.5L7.3 5.47c1.44-.62 3.03-.97 4.7-.97M3.18 12A9.821 9.821 0 0 0 12 17.5c.69 0 1.37-.07 2-.21L11.72 15A3.064 3.064 0 0 1 9 12.28L5.6 8.87c-.99.85-1.82 1.91-2.42 3.13"></path></svg>`,
                }}
              />
            )}
          </button>
        </div>
      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error.message}</p>}
      {label2 && <label className="label mt-2">{label2}</label>}
    </div>
  );
};

export default PasswordInput;
